export default "__VITE_ASSET__CSPjhGb6__"